import { Component } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { v4 as uuidV4 } from 'uuid';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ToggleComponent,
    },
  ],
  imports: [FormsModule],
})
export class ToggleComponent implements ControlValueAccessor {
  public checked: boolean = false;
  public id: string;
  public touched = false;
  public disabled = false;

  constructor() {
    this.id = uuidV4();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: (checked: boolean) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouched: () => void = () => {};

  public writeValue(value: boolean): void {
    this.checked = value;
  }

  public registerOnChange(fn: (checked: boolean) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public onCheckedChanged(checked: boolean): void {
    this.markAsTouched();
    this.onChange(checked);
    this.checked = checked;
  }

  public stopPropagation(e: Event): boolean {
    e.stopPropagation();
    return true;
  }
}
